module.exports = __webpack_public_path__ + "img/big_1_24.18a8403e.png";